import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Text } from '@mantine/core';
export default memo(({ data, style }) => (
  <div className="wrapper gradient" style={style}>
    {' '}
    {/* Apply style here */}
    <div className="inner">
      <div className="body">
        {data.icon && <div className="icon">{data.icon}</div>}
        <div>
          <Text w={100} truncate="end">
            {data.title}
          </Text>
          {data.subline && <div className="subline">{data.subline}</div>}
        </div>
      </div>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
    </div>
  </div>
));
